"use client";

import { useTranslations } from "use-intl";

import { Price } from "@/components/Price";
import { cn } from "@/lib/utils";

export function DealOfferFormatTabDetails({
  active,
  offerCount,
  outOfStock,
  price,
  currency,
}: {
  active: boolean;
  offerCount: number;
  outOfStock: boolean;
  price?: string | null;
  currency?: string | null;
}) {
  const t = useTranslations("shared.affiliates");

  return (
    <span className="ml-auto flex shrink-0 items-center gap-2">
      {price && currency && (
        <Price amount={price} currency={currency} compact className="font-bold" />
      )}
      {outOfStock && (
        <span className="whitespace-nowrap text-xs font-bold text-muted-foreground">
          {t("outOfStock")}
        </span>
      )}
      {offerCount > 1 && (
        <span
          className={cn(
            "rounded-full px-1.5 py-0.5 text-xs font-bold tabular-nums",
            active ? "bg-primary/15 text-primary" : "bg-muted text-muted-foreground",
          )}
        >
          {offerCount}
        </span>
      )}
    </span>
  );
}
